import React, { useContext } from 'react';
import plus from '@images/wysiwyg_editor/add_button_plus.svg';
import { ImageCacheDispatchContext } from '@src/contexts/wysiwyg/image_cache';
import useFilestackUploader from '@src/hooks/useFilestackUploader';

export default function AddPhotos(): React.ReactElement {
  const { addImageByUrl } = useContext(ImageCacheDispatchContext);
  const handleFilestackUpload = useFilestackUploader();

  return (
    <button
      type="button"
      className="wysiwyg-editor-toolbox-drawer-layout-addimage"
      onClick={() =>
        handleFilestackUpload({
          onImageUploadSuccess: (imageEl: HTMLImageElement) =>
            addImageByUrl(imageEl.src)
        })
      }
    >
      <img src={plus as string} alt="" /> Add Photos
    </button>
  );
}
